import React, { Component } from 'react';
import styles from './TabletPreview.css';
import akulakuLogo from '../images/akulaku-logo.png';
import alipayLogo from '../images/alipay-logo.png';
import danaLogo from '../images/dana-logo.png';
import gopayLogo from '../images/gopay-logo.png';
import kredivoLogo from '../images/kredivo-logo.png';
import linkajaLogo from '../images/linkaja-logo.png';
import ovoLogo from '../images/ovo-logo.png';
import wechatpayLogo from '../images/wechatpay-logo.png';
import shopeepayLogo from '../images/shopeepay-logo.png';

function CashSegment(props) {
  const { selectedPaymentMethods } = props;
  const isCashSelected = selectedPaymentMethods.some(
    method => method.code === 'cash'
  );

  if (!isCashSelected) {
    return null;
  }

  return (
    <div className={styles.segment}>
      <div className={styles.title} id="cash">
        Cash
      </div>
      <div className={styles.content}>
        <div className={styles.button}>Rp 17.000</div>
        <div className={styles.button}>Rp 20.000</div>
        <div className={styles.button}>Rp 25.000</div>
        <div className={styles.input}>Rp 17.000</div>
      </div>
    </div>
  );
}

function EwalletSegment(props) {
  const { selectedPaymentMethods } = props;

  const selectedEwallet = selectedPaymentMethods.filter(
    paymentMethod => paymentMethod.category.code === 'e-wallet'
  );

  const paymentMethodLogos = {
    akulaku: akulakuLogo,
    alipay: alipayLogo,
    dana: danaLogo,
    gopay: gopayLogo,
    kredivo: kredivoLogo,
    tcash: linkajaLogo,
    ovo: ovoLogo,
    wechatpay: wechatpayLogo,
    shopeepay: shopeepayLogo,
  };

  const ewalletDisplay = selectedEwallet.map(paymentMethod => {
    return (
      <div className={styles.button} key={paymentMethod.id}>
        {paymentMethodLogos[paymentMethod.code] ? (
          <img src={paymentMethodLogos[paymentMethod.code]} />
        ) : (
          paymentMethod.name
        )}
      </div>
    );
  });

  // the whole segment is not displayed if no e-wallet method selected
  if (ewalletDisplay.length === 0) {
    return <div />;
  }

  return (
    <div className={styles.segment}>
      <div className={styles.title}>E-Wallet</div>
      <div className={styles.content}>{ewalletDisplay}</div>
    </div>
  );
}

function EdcSegment(props) {
  const { selectedPaymentMethods } = props;

  const selectedEdc = selectedPaymentMethods.filter(
    paymentMethod => paymentMethod.category.code === 'edc'
  );

  const edcDisplay = selectedEdc.map(paymentMethod => {
    return (
      <div className={styles.button} key={paymentMethod.id}>
        {paymentMethod.name}
      </div>
    );
  });

  if (edcDisplay.length === 0) {
    return <div />;
  }

  return (
    <div className={styles.segment}>
      <div className={styles.title}>EDC</div>
      <div className={styles.content}>{edcDisplay}</div>
    </div>
  );
}

function OtherSegment(props) {
  const { selectedPaymentMethods } = props;

  const selectedOther = selectedPaymentMethods.filter(
    paymentMethod => paymentMethod.category.code === 'other'
  );

  const otherDisplay = selectedOther.map(paymentMethod => {
    return (
      <div className={styles.button} key={paymentMethod.id}>
        {paymentMethod.name}
      </div>
    );
  });

  if (otherDisplay.length === 0) {
    return <div />;
  }

  return (
    <div className={styles.segment}>
      <div className={styles.title}>Other</div>
      <div className={styles.content}>{otherDisplay}</div>
    </div>
  );
}

function InvoiceSegment(props) {
  const { selectedPaymentMethods } = props;

  const selectedInvoice = selectedPaymentMethods.filter(
    paymentMethod => paymentMethod.category.code === 'invoice'
  );

  const invoiceDisplay = selectedInvoice.map(paymentMethod => {
    return (
      <div className={styles.button} key={paymentMethod.id}>
        {paymentMethod.name}
      </div>
    );
  });

  if (invoiceDisplay.length === 0) {
    return <div />;
  }

  return (
    <div className={styles.segment}>
      <div className={styles.title}>Invoice</div>
      <div className={styles.content}>{invoiceDisplay}</div>
    </div>
  );
}

function CardSegment(props) {
  const { selectedPaymentMethods } = props;

  const selectedCard = selectedPaymentMethods.filter(
    paymentMethod => paymentMethod.category.code === 'card'
  );

  const cardDisplay = selectedCard.map(paymentMethod => {
    return (
      <div className={styles.button} key={paymentMethod.id}>
        {paymentMethod.name}
      </div>
    );
  });

  if (cardDisplay.length === 0) {
    return <div />;
  }

  return (
    <div className={styles.segment}>
      <div className={styles.title}>Card</div>
      <div className={styles.content}>{cardDisplay}</div>
    </div>
  );
}

class TabletPreview extends Component {
  render() {
    const { selectedPaymentMethods } = this.props;

    return (
      <div className={styles.parentContainer}>
        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.buttonCancel}>Cancel</div>
            <div>Rp 17.000</div>
            <div className={styles.buttonCharge}>Charge</div>
          </div>
          <div className={styles.parentContent}>
            <CashSegment selectedPaymentMethods={selectedPaymentMethods} />
            <EwalletSegment selectedPaymentMethods={selectedPaymentMethods} />
            <EdcSegment selectedPaymentMethods={selectedPaymentMethods} />
            <OtherSegment selectedPaymentMethods={selectedPaymentMethods} />
            <InvoiceSegment selectedPaymentMethods={selectedPaymentMethods} />
            <CardSegment selectedPaymentMethods={selectedPaymentMethods} />
          </div>
        </div>
      </div>
    );
  }
}

export default TabletPreview;
